import { FigureIcon, HelpIcon } from "@/assets/icons";
import styles from "./Content.module.scss";
import FTStyleLableList from "./StylesLable";
import StylesList from "./StylesList";
import LeftCusContent from "./CusContent";
import useEffectStore from "@/stores/effectStore";
// import { GenerateButton } from "@/components";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const LeftContent = () => {
  const { t } = useTranslation();
  const isOpenPanel = useEffectStore((state) => state.customPanel.visible);
  const setGuidTipShow = useEffectStore((state) => state.setGuidTipShow);
  const generating = useEffectStore((state) => state.generating);
  const labelList = useEffectStore((state) => state.labelListObj.arr);
  // const generating = true;
  const showList = labelList.length > 1;
  const handleShowTip = () => {
    setGuidTipShow(true);
  };
  return (
    <div className={styles["container"]}>
      <div className={styles["header"]}>
        <FigureIcon
          style={{
            marginRight: "6px",
          }}
          width={16}
        />
        {t("feature_name")}
        <HelpIcon
          style={{
            marginLeft: "6px",
            cursor: "pointer",
          }}
          width={16}
          onClick={handleShowTip}
        />
      </div>
      {isOpenPanel && <LeftCusContent />}

      {/* <div className={styles["show-pop"]}>
        <p>Mutiple Face Swap</p>
      </div> */}

      {showList && <FTStyleLableList className={styles["lable-margin"]} />}
      <div
        style={{
          flex: 1,
          minHeight: 0,
        }}
      >
        <StylesList />
      </div>
      {/* <GenerateButton
        className={styles["gen-btn"]}
        beforeClick={() => {
          return true;
        }}
        // text="Generate"
        // disabled={false}
      /> */}
      {/* {generating && (
        <div
          className={styles.generatingMask}
          onClick={() => {
            toast(t("before_generate"), {
              autoClose: 3000,
              toastId: "before_generate",
              // hideProgressBar: false,
              closeOnClick: true,
              progress: undefined,
            });
          }}
        ></div>
      )} */}
    </div>
  );
};

export default LeftContent;
